// extracted by mini-css-extract-plugin
export default {"afterPayModeSection":"h4-z","refreshPageWarning":"i4-z","redirectMessageText":"j4-z"};